/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

import React, { useContext, useEffect, useRef, useState } from "react";
import "./fareTable.css";
import axios from "axios";
import format from "date-fns/format";
import Collapse from "react-bootstrap/Collapse";
import Placeholder from "react-bootstrap/Placeholder";
import PLANE_ICON from "../../images/plane-icon.svg";
import ARROW_DOWN_ICON from "../../images/arrow-down.png";
import ARROW_UP_ICON from "../../images/arrow-up.png";
import { GET_FARE_TABLE_DATA } from "../../routes";
import {
  FareTableDispatchContext,
  FareTableStateContext,
} from "../../contexts/fareTableData";
import {
  FlightDataDispatchContext,
  FlightDataStateContext,
} from "../../contexts/flightData";
import UrlParamsContext from "../../contexts/urlParams";
import { ReviewBannerDispatchContext } from "../../contexts/reviewBannerContext";
import { DEFAULT_DATE_FORMAT, FARE_TABLE_DATE_FORMAT } from "../../constants";

let intersectionObserver = null;
let options = {
  rootMargin: "0px",
};
let clickedTableItem = false;

const FareTable = (props) => {
  const data = useContext(FareTableStateContext);
  const setData = useContext(FareTableDispatchContext);
  const {
    originCity,
    destCity,
    originCode,
    destCode,
    depDate,
    retDate,
    tripType,
    updateMetaTagValue,
  } = useContext(FlightDataStateContext);
  const setFlightData = useContext(FlightDataDispatchContext);
  const urlParams = useContext(UrlParamsContext);
  const setShowReviewBanner = useContext(ReviewBannerDispatchContext);
  const [loading, setLoading] = useState(true);
  const [lastUpdateTime, setLastUpdateTime] = useState(Date.now());
  const [open, setOpen] = useState(false);
  const [airlineName, setAirlineName] = useState("");
  const [heading, setHeading] = useState("");
  const containerRef = useRef();
  const initialMount = useRef(true);

  const [getAirlineStatus, setAirlineStatus] = useState(false);
  const [showAirlinePara, setAirlinePara] = useState(false);
  const [showCityPairPara, setshowCityPairPara] = useState(false);
  const [ShowDesPara, setShowDesPara] = useState(false);
  const [showDefaultPara, setshowDefaultPara] = useState(false);
  useEffect(() => {
    const fetchFareTableData = async (entries) => {
      if (entries && entries.length && entries[0].isIntersecting) {
        try {
          setLoading(true);
          const params = {
            origin: originCode,
            destination: destCode,
            dep_dt: depDate ? format(depDate, DEFAULT_DATE_FORMAT) : "",
            ret_dt: retDate ? format(retDate, DEFAULT_DATE_FORMAT) : "",
            trip: tripType,
            arl: urlParams.arl,
          };
          const { data } = await axios.get(GET_FARE_TABLE_DATA, { params });
          setData(data.data && data.data.length ? data.data : []);
          setAirlineName(data.arl_name);
          setLastUpdateTime(Date.now());
          setLoading(false);
          intersectionObserver.disconnect();
          intersectionObserver = null;
        } catch (err) {
          setLoading(false);
        }
      }
    };

    if (initialMount.current) initialMount.current = false;

    if (!clickedTableItem && !!originCode.trim()) {
      intersectionObserver?.disconnect();
      intersectionObserver = new IntersectionObserver(
        fetchFareTableData,
        options
      );
      intersectionObserver.observe(containerRef.current);
    } else {
      clickedTableItem = false;
    }
  }, [originCode, destCode, depDate, retDate, tripType, urlParams, setData]);

  useEffect(() => {
    if (airlineName || destCity || originCity) {
      if (airlineName) setHeading({ pre: "", value: airlineName });
      else if (destCity) setHeading({ pre: "To", value: destCity });
      else setHeading({ pre: "From", value: originCity });
    }
  }, [airlineName, destCity, originCity]);

  const handleFareTableItemClick = (data) => {
    setFlightData((prevState) => ({
      ...prevState,
      origin: data.from.airportName,
      originCode: data.from.airportCode,
      originCity: data.from.cityName,
      originRegion: data.from.region,
      destination: data.to.airportName,
      destCode: data.to.airportCode,
      destCity: data.to.cityName,
      destRegion: data.to.region,
      depDate: format(data.fare_detail.depart_dt, DEFAULT_DATE_FORMAT),
      retDate: data.fare_detail.return_dt
        ? format(data.fare_detail.return_dt, DEFAULT_DATE_FORMAT)
        : "",
    }));
    setShowReviewBanner(true);
    window.scroll({ top: 0, behavior: "smooth" });
  };
  // ...............................................
  useEffect(() => {
    handleParaContent(updateMetaTagValue);
  }, [updateMetaTagValue]);

  function CheckValueAirlineStatus(value) {
    let arr = ["AS", "G4", "AA", "DL", "F9", "HA", "B6", "WN", "NK", "UA"];

    const res5 = arr.find((elem) => elem === value.toUpperCase());
    setAirlineStatus(Boolean(res5));
  }
  var checkValueExist = (data) => {
    if (data === null || data === undefined || data === "") {
      return false;
    } else {
      return true;
    }
  };
  const handleParaContent = (updateMetaTagValue) => {

    if (updateMetaTagValue !== undefined) {
      if (
        checkValueExist(urlParams.arl) === true &&
        checkValueExist(urlParams.name) === true
      ) {
        CheckValueAirlineStatus(urlParams.arl);
        setAirlinePara(true);
      } else if (
        checkValueExist(urlParams.arl) === true &&
        checkValueExist(urlParams.name) === false
      ) {
        CheckValueAirlineStatus(urlParams.arl);

        setAirlinePara(true);
      } else if (
        checkValueExist(urlParams.ori) === true &&
        checkValueExist(urlParams.des) === true
      ) {
        setshowCityPairPara(true);
      } else if (checkValueExist(urlParams.des) === true) {
        setShowDesPara(true);
      } else {
        setshowDefaultPara(true);
      }
    }
  };
  // .................................................
  return (
    <div className="container" ref={containerRef}>
      <div className="row chpFare">
        <div className="col-xs-12">
          <h1>
            {loading ? (
              <>
                <Placeholder animation="glow">
                  <Placeholder bg="secondary" style={{ width: "100%" }} />
                </Placeholder>
                <Placeholder animation="glow">
                  <Placeholder bg="secondary" style={{ width: "40%" }} />
                </Placeholder>
              </>
            ) : (
              urlParams &&
              (urlParams.check_ln || (
                <>
                  Check Out{" "}
                  {airlineName
                    ? `${heading.value} Deals`
                    : destCode
                    ? `Our Fares ${heading.pre} ${
                        props.mainCityName
                          ? props.mainCityName.from.cityName
                          : heading.value
                      }`
                    : `Our Fares ${heading.pre} ${
                        props.mainCityName
                          ? props.mainCityName.from.cityName
                          : heading.value
                      }`}
                  !
                </>
              ))
            )}
          </h1>
          <p>
            {!loading ? (
              <>
                <span className="offer_txt">
                  {showDefaultPara
                    ? `Book cheap, discounted prices on airline tickets at CheapFareGuru on most airlines worldwide. Call our travel experts 24x7x365 for help and great deals. `
                    : null}

                  {showAirlinePara && (
                    <>
                      {getAirlineStatus ? (
                        <>
                          CheapFareGuru offers {airlineName}&nbsp;discounted
                          prices and nonstop flights nationwide. Search,
                          compare, book, and save on&nbsp;{airlineName}
                          &nbsp;flights nationwide. Call our travel experts
                          for&nbsp;{airlineName}&nbsp;reservations for super
                          deals. Experts are available 24x7x365 to help!
                        </>
                      ) : (
                        <>
                          CheapFareGuru offers {airlineName}&nbsp;discounted
                          prices and nonstop flights nationwide. Search,
                          compare, book, and save on&nbsp;
                          {airlineName}&nbsp;flights worldwide. Call our travel
                          experts for&nbsp;{airlineName}&nbsp;reservations for
                          super deals. Experts are available 24x7x365 to help!
                        </>
                      )}
                    </>
                  )}

                  {showCityPairPara ? (
                    <>
                      CheapFareGuru.com offers special discount tickets
                      between&nbsp;
                      {updateMetaTagValue.OriginairportCity} (
                      {updateMetaTagValue.OriginairportCode}) and&nbsp;
                      {updateMetaTagValue.destairportCity} (
                      {updateMetaTagValue.destairportCode}) for both round-trip
                      and one-way travel. Now it's time to book your cheap
                      flight to&nbsp;
                      {updateMetaTagValue.destairportCity}&nbsp;(
                      {updateMetaTagValue.destairportCode}). These prices won't
                      last! Save more by booking your flight to&nbsp;
                      {updateMetaTagValue.destairportCity}&nbsp;today.
                    </>
                  ) : null}

                  {ShowDesPara ? (
                    <>
                      CheapFareGuru.com offers special discount tickets to&nbsp;
                      {updateMetaTagValue.destairportCity} (
                      {updateMetaTagValue.destairportCode})&nbsp;for both
                      round-trip and one-way travel. Now it's time to book your
                      cheap flight to&nbsp;{updateMetaTagValue.destairportCity}{" "}
                      ({updateMetaTagValue.destairportCode}).&nbsp;These prices
                      won't last! Save more by booking your flight to&nbsp;
                      {updateMetaTagValue.destairportCity}&nbsp;today.
                    </>
                  ) : null}
                </span>
              </>
            ) : (
              <>
                <Placeholder animation="glow">
                  <Placeholder bg="secondary" style={{ width: "100%" }} />
                </Placeholder>
                <Placeholder animation="glow">
                  <Placeholder bg="secondary" style={{ width: "100%" }} />
                </Placeholder>
              </>
            )}
          </p>
          <p className="smTxt">
            {!loading ? (
              <>
                * Displayed fares were last updated on{" "}
                <span className="red-txt">
                  {format(lastUpdateTime, FARE_TABLE_DATE_FORMAT)} at{" "}
                  {format(lastUpdateTime, "h:mm:ss A")}
                  <button
                    className="btn collapse-toggle-btn"
                    onClick={() => setOpen(!open)}
                    aria-controls="baggage_m"
                    aria-expanded={open}
                  >
                    {open ? "Read Less " : "Read More "}
                    <img src={open ? ARROW_UP_ICON : ARROW_DOWN_ICON} alt="" />
                  </button>
                </span>
              </>
            ) : (
              <>
                <Placeholder animation="glow">
                  <Placeholder bg="secondary" style={{ width: "100%" }} />
                </Placeholder>
                <Placeholder animation="glow">
                  <Placeholder bg="secondary" style={{ width: "100%" }} />
                </Placeholder>
              </>
            )}
          </p>
          <Collapse in={open}>
            <div id="baggage_m">
              Fares are based on historical data, are subject to change and
              cannot be guaranteed at the time of booking. Total fare round trip
              economy className per person in US dollars, including all taxes
              and fees.
            </div>
          </Collapse>
        </div>
      </div>
      <div className="row list_pad_main">
        {!loading ? (
          !!data.length ? (
            data.map((item, index) => {
              const { from, to, fare_detail } = item;
              return (
                <div
                  key={index + fare_detail.fare + fare_detail.arl_code}
                  className="col-xs-12 list_pad"
                  onClick={() => {
                    handleFareTableItemClick(item);
                    clickedTableItem = true;
                  }}
                >
                  <div className="wrap">
                    <div className="ico-wrap" style={{ width: "12%" }}>
                      <img src={fare_detail.arl_logo} alt="" />{" "}
                    </div>
                    <div className="vcenter">
                      <h2 className="mbr-bold mbr-section-title3 display-5">
                        <div className="first" style={{ width: "45%" }}>
                          {from.cityName}{" "}
                          <p className="display-6">
                            {format(
                              fare_detail.depart_dt,
                              FARE_TABLE_DATE_FORMAT
                            )}
                          </p>
                        </div>{" "}
                        <span className="second" style={{ width: "10%" }}>
                          <img className="" src={PLANE_ICON} alt="" />
                        </span>
                        <div className="third" style={{ width: "45%" }}>
                          {" "}
                          {to.cityName}
                          {tripType === "RT" && (
                            <p className="display-6">
                              {format(
                                fare_detail.return_dt,
                                FARE_TABLE_DATE_FORMAT
                              )}
                            </p>
                          )}
                        </div>
                      </h2>
                    </div>
                    <div
                      className="icon-wrap-price pull-right"
                      style={{ width: "18%" }}
                    >
                      {" "}
                      ${fare_detail.fare}*{" "}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-xs-12 list_pad">
              <div className="no-fare">
                No {airlineName ? "deals" : "fares"} found for {heading.value}{" "}
                {!airlineName && `(${destCode || originCode})`}
              </div>
            </div>
          )
        ) : (
          [1, 2, 3, 4, 5].map((e) => (
            <div key={`skeleton-${e}`} className="col-xs-12 list_pad">
              <div className="skeleton-wrap">
                <Placeholder animation="glow">
                  <Placeholder
                    bg="secondary"
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "50%",
                    }}
                  />
                </Placeholder>
                <div style={{ width: "calc(100% - 44px)", padding: "0 10px" }}>
                  <Placeholder animation="glow">
                    <Placeholder
                      bg="secondary"
                      style={{ width: "90%", height: "16px" }}
                    />
                  </Placeholder>
                  <Placeholder animation="glow">
                    <Placeholder
                      bg="secondary"
                      style={{ width: "75%", height: "12px" }}
                    />
                  </Placeholder>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FareTable;
